export default __webpack_public_path__ + "static/media/fashion-exclusive-license.add9d496.jpg";